import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'mc0165',
    ecrans: ['00-2'],
    params: ['id']
});
